import React, { useEffect, useRef, useState } from "react";
import style from "./search.module.css";
import { Row, Col, Form, Button, InputGroup, Dropdown } from "react-bootstrap";

import { getAllCenters, getcountrieswhereCampaigns } from "../../apis/CenterApis";
import { useDispatch } from "react-redux";
import { searchSuggestion } from "../../apis/CenterApis";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { searchCenters } from "../../apis/CenterApis";
// import { fileBaseUrl } from "../../utils/api";
import VideoPlayer from "../../modals/videoPlayer/VideoPlayer";
import { Helmet } from "react-helmet-async";
import { getStateForCountry } from "../../apis/CenterApis";
import { Country, State } from "country-state-city";
import axios from "axios";
import { baseUrl } from "../../utils/api";

const SearchCenter = () => {
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const location = useLocation();
  const [centerList, setCenterList] = useState();
  const [searchCenter, setSearchCenter] = useState(null);
  const [showfilter, setShowFilter] = useState(null);
  const [debouncedQuery, setDebouncedQuery] = useState(null);
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [suggestionList, setSuggestionList] = useState(null);
  const [selectedSuggest, setSelectedSuggest] = useState(null);
  const [totalcenter, setTotalCenter] = useState(0);
  const [selectedStates, setSelectedStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");


  useEffect(() => {
    dispatch(getcountrieswhereCampaigns()).then((res) => {
      if (res?.countries?.length) {
        const countries = res.countries
          .filter(country => country !== null)
          .map(countryName => {
            const country = Country.getAllCountries().find(c => c.name.toLowerCase() === countryName.toLowerCase());
            return country || { name: countryName }; // Fallback if country not found
          });
        setCountries(countries);
      }
    });
  }, []);

  // useEffect(() => {
  //     if (selectedCountry) {
  //       setStates(State.getStatesOfCountry(selectedCountry?.isoCode));
  //       setSelectedState("");
  //     }
  //   }, [selectedCountry]);

  const getAllCamapigns = () => {
    dispatch(getAllCenters({ page: 1, limit: 20 })).then((res) => {
      if (res?.centersList) {
        console.log("res", res?.totalCenters)
        setCenterList(res?.centersList);
        setTotalCenter(res?.totalCenters);
        setPage(1);
        setLoadMore(true);
      }
    });
  }

  useEffect(() => {
    if (location?.state) {
      setSearchCenter(location?.state);
      const timerId = setTimeout(() => {
        setSelectedSuggest(location?.state);
        setShowFilter(location?.state);
        setShowSuggestion(false);
      }, 300);
      return () => clearTimeout(timerId);
    } else {
      getAllCamapigns();
    }
  }, [location]);

  const countryDropdownRef = useRef(null);
  const stateDropdownRef = useRef(null);



  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowSuggestion(false);

      }
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target) &&
        stateDropdownRef.current &&
        !stateDropdownRef.current.contains(event.target)
      ) {
        setShowCountryDropdown(false);
        setShowStateDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  function truncateString(str, maxLength) {
    if (str?.length <= maxLength) {
      return str;
    } else {
      return str?.slice(0, maxLength) + "...";
    }
  }

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedQuery(searchCenter);
    }, 300);

    return () => clearTimeout(timerId);
  }, [searchCenter]);

  useEffect(() => {
    if (debouncedQuery && !selectedSuggest) {
      dispatch(searchSuggestion({ search: debouncedQuery })).then((res) => {
        if (res?.length) {
          setShowSuggestion(true);
          setSuggestionList(res);
        } else {
          setShowSuggestion(false);
        }
      });
    } else {
      setShowSuggestion(false);
    }
  }, [debouncedQuery]);

  // const handleSearch = () => {
  //   setShowFilter(searchCenter);
  //   setShowSuggestion(false);
  //   setSelectedSuggest(null);
  // };
  const handleChange = (e) => {
    let value = e.target.value
    setSelectedSuggest(null);
    setSearchCenter(value);
    if (value.trim() === "" && !centerList) {
      getAllCamapigns();
    }
  };

  const handleSuggestion = (value) => {
    setSearchCenter(value);
    setSelectedSuggest(value);
    setShowFilter(value);
    setShowSuggestion(false);
  };

  const navigate = useNavigate();

  const [files, setFiles] = useState([]);
  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [showNext, setShowNext] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(9);
  // const [isdata, setIsData] = useState(false);
  const [loadMore, setLoadMore] = useState(false);
  const [liveSet, setLiveSet] = useState(new Set());
  const [liveMeta, setLiveMeta] = useState({});

  const sanitizeFolderName = (name) => {
    if (!name || typeof name !== 'string') return '';
    let clean = name.replace(/[^a-zA-Z0-9-_\s]/g, '_');
    clean = clean.replace(/[\s-_]+/g, ' ').trim();
    clean = clean.replace(/\s+/g, '_');
    return clean;
  };

  // useEffect(() => {
  //   const host = window.location.hostname;
  //   const primary = (host === 'localhost' || host === '127.0.0.1') ? 'http://localhost:5000' : baseUrl.replace('/v1','');
  //   const fallback = (primary.includes('localhost')) ? baseUrl.replace('/v1','') : 'http://localhost:5000';
  //   const candidates = [primary, fallback].filter((v, i, arr) => arr.indexOf(v) === i);

  //   let timer = null;
  //   const poll = async () => {
  //     for (const root of candidates) {
  //       try {
  //         const res = await axios.get(`${root}/v1/stream/live`, {
  //           params: { ts: Date.now() },
  //           headers: { 'Cache-Control': 'no-cache' }
  //         });
  //         if (res && res.status === 200) {
  //           const live = res.data?.folders || [];
  //           setLiveSet(new Set(live));
  //           setLiveMeta(res.data?.meta || {});
  //         }
  //         break;
  //       } catch (_) {
  //       }
  //     }
  //   };
  //   poll();
  //   timer = setInterval(poll, 3000);
  //   return () => { if (timer) clearInterval(timer); };
  // }, []);

  const filesData = (value) => {
    const addfileType = value?.map((file) => {
      const fileExtension = file?.media?.split(".").pop().toLowerCase();
      const imageExtensions = ["jpg", "jpeg", "png", "gif"];
      const videoExtensions = ["mp4", "avi", "mov", "mkv"];
      const youtubePattern =
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
      if (imageExtensions.includes(fileExtension)) {
        file.type = "image";
      }
      else if (youtubePattern.test(file.media)) {
        file.type = "youtube";
      }
      else if (videoExtensions.includes(fileExtension)) {
        file.type = "video";
      }
      else {
        file.type = "unsupported";
      }

      // setIsData(true);
      return file;
    });
    return addfileType;
  };

  const fetchSearchCenter = () => {
    if (!searchCenter) {
      setFiles(filesData(centerList)); // Reset files if searchCenter is empty
      return;
    }
    setLoadMore(false);

    dispatch(
      searchCenters({
        centerName: searchCenter,
        page: page,
        limit: limit,
      })
    ).then((res) => {
      if (res) {
        setFiles(filesData(res?.centersList));
        setPage(res?.currentPage);
        if (res?.currentPage < res?.totalPages) {
          setShowNext(true);
        } else {
          setShowNext(false);
        }
      }
    });
  };

  useEffect(() => {
    setFiles(filesData(centerList));
  }, [centerList]);

  useEffect(() => {
    if (!searchCenter) {
      setFiles(filesData(centerList));
    }
    else {
      setSelectedStates([])
    }
    // if (selectedStates.length == 0) {
    //   setFiles(filesData(centerList));
    // }


  }, [searchCenter]);

  useEffect(() => {
    if (selectedStates.length == 0) {
      setFiles(filesData(centerList));
    } else {
      setSearchCenter("");
    }



  }, [selectedStates]);

  useEffect(() => {
    if (showfilter && searchCenter) {
      fetchSearchCenter();
    }
  }, [showfilter]);

  const handleClick = (data) => {
    console.log("dataaaaa....", data)
    navigate(`/donation/${data.slug}`)

    // navigate(`/donation/${data.id ? data.id : data._id}`);

    localStorage.setItem("centerId", data.id ? data.id : data._id);
  };


  const handlePlay = (url) => {
    setVideoUrl(url);
    setShowVideoPlayer(true);
  };

  const handleShowMore = () => {
    setLoadMore(false);

    // Determine which filter to apply
    const filters = {
      page: page + 1,
      limit: limit,
    };

    if (searchCenter != null) {
      filters.centerName = searchCenter; // Add searchCenter filter if provided
    }

    if (selectedStates.length > 0) {
      filters.centerName = selectedStates; // Add selectedState filter if provided
    }

    dispatch(searchCenters(filters)).then((res) => {
      if (res) {
        setFiles((prev) => [...prev, ...filesData(res?.centersList)]);
        setPage(res?.currentPage);
        if (res?.currentPage < res?.totalPages) {
          setShowNext(true);
        } else {
          setShowNext(false);
          setPage(1);
        }
      }
    });
  };



  // useEffect(() => {
  //   dispatch(getAllCenters({ page: 1, limit: 20 })).then((res) => {
  //     if (res?.centersList) {
  //       setCenterList(res?.centersList);
  //       setTotalCenter(res?.toatalCenters);
  //       setPage(1);
  //       setLoadMore(true);
  //     }
  //   });
  // }, []);

  const handleLoadMore = () => {
    const nextPage = page + 1;

    dispatch(
      getAllCenters({
        page: nextPage,
        limit: 20
      })
    ).then((res) => {
      if (res?.centersList) {
        setCenterList((prev) => [...prev, ...res.centersList]);
        setPage(nextPage);

        if (nextPage < res.totalPages) {
          setLoadMore(true);
        } else {
          setLoadMore(false);
        }
      }
    });
  };

  function truncateText(text, maxLength) {
    if (text.length <= maxLength) {
      return `, ${text}`;
    }
    return `, ${text.substr(0, maxLength) + "..."}`;
  }


  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [showStateDropdown, setShowStateDropdown] = useState(false);

  const [availableStates, setAvailableStates] = useState([]);

  const [centerData, setCenterData] = useState([]);

  // const countrylist = [
  //   {
  //     isoCode: "CA",
  //     name: "Canada",
  //   },
  //   {
  //     isoCode: "MX",
  //     name: "Mexico",
  //   },
  //   {
  //     isoCode: "PR",
  //     name: "Puerto Rico",
  //   },
  //   {
  //     isoCode: "US",
  //     name: "United States",
  //   },
  //   {
  //     isoCode: 'GB', // Correct ISO code for United Kingdom
  //     name: 'United Kingdom'
  //   },
  //   {
  //      isoCode: 'AU', // Correct ISO code for United Kingdom
  //     name: 'Australia'
  //   }
  // ];



  const handleCountryClick = (country) => {
    if (country.name === "Puerto Rico") {
      setShowCountryDropdown(false);
      setShowStateDropdown(false);
      return;
    }

    dispatch(getStateForCountry({ country: country.name })).then((res) => {
      if (res?.states?.length > 0) {
        setAvailableStates(res.states);
        setShowStateDropdown(true);
      } else {
        setAvailableStates([]);
        setShowStateDropdown(false);
      }
    });
  };

  const handleStateClick = (state) => {
    if (!selectedStates.includes(state)) {
      setSelectedStates((prev) => [...prev, state]);
      fetchStateData([...selectedStates, state]); // Fetch data for all selected states
    }

    setShowStateDropdown(false);
    setShowCountryDropdown(false);
  };

  // Remove a state and update the data
  const handleStateRemove = (stateToRemove) => {
    const updatedStates = selectedStates.filter(
      (state) => state !== stateToRemove
    );
    setSelectedStates(updatedStates);
    fetchStateData(updatedStates); // Fetch data for remaining states
    setCenterData([]);
  };

  const fetchStateData = (selectedStates) => {
    if (!selectedStates || selectedStates.length === 0) {
      setFiles(filesData(centerList)); // Reset files if no states are selected
      return;
    }
    setLoadMore(false);

    dispatch(
      searchCenters({
        centerName: selectedStates, // Ensure this is safe (defaults handled above)
        // Pass the selected country if applicable
        state: selectedStates.join(","), // Send states as a comma-separated string
        page: page,
        limit: limit,
      })
    ).then((res) => {
      if (res) {
        setFiles(filesData(res?.centersList || []));
        setCenterData(filesData(res?.centersList || []));
        if (res?.currentPage < res?.totalPages) {
          setShowNext(true);
        } else {
          setShowNext(false);
          setPage(1);
        }
      }
    });
  };

  function getYouTubeVideoId(url) {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|.+\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  const stripHtmlAndMarkdown = (text) => {
    if (!text) return "";

    // remove HTML tags
    let clean = text.replace(/<[^>]*>/g, "");

    // remove markdown symbols
    clean = clean.replace(/[*_#>-]/g, "");

    return clean;
  };

  return (
    <>
      <Helmet>
        <title>Search Campaigns for Church, Family & Community Causes.
        </title>
        <meta
          name="description"
          content="Search and explore fundraising campaigns on FundLife, connecting donors with causes supported by churches, families, and community initiatives—covering family assistance, pregnancy help, adoption support, and other life-affirming ministries"
        />
        <meta
          property="og:description"
          content="Search and explore fundraising campaigns on FundLife, connecting donors with causes supported by churches, families, and community initiatives—covering family assistance, pregnancy help, adoption support, and other life-affirming ministries."
        />
        <meta
          name="keywords"
          content="fundraising campaign search, church campaign search, family support fundraising, community causes platform, adoption support campaigns, pregnancy assistance fundraising, family ministry crowdfunding."
        />
      </Helmet>
      <div style={{ height: "80px" }} />

      <div className="mt-5">
        {/* <div className={style.centerHeading}>
          Whether it's a pregnancy help center, maternity home, or an adoption
          agency, they're all here.
        </div> */}
        <div className="mt-4 mb-5">
          <Row className="m-0 p-0">
            <Col
              lg={{ span: 6, offset: 3 }}
              md={{ span: 8, offset: 2 }}
              xs={12}>
              <InputGroup>
                <Form.Control
                  className={style.serchInputsec}
                  placeholder="Search"
                  aria-label="Recipient's username"
                  aria-describedby="basic-addon2"
                  value={searchCenter}
                  onChange={handleChange}
                />

                <div className="position-relative" >
                  <Button
                    className={`${style.serchInputbtn} redbtn`}
                    variant="danger"
                    id="button-addon2"
                    onClick={() => setShowCountryDropdown(!showCountryDropdown)}>
                    Filter
                  </Button>
                  <div ref={countryDropdownRef}>

                    <Dropdown.Menu

                      className={` ${style.drpdwn}`}
                      show={showCountryDropdown}>
                      <Dropdown.Item disabled>Countries</Dropdown.Item>
                      {/* {{countries}} */}
                      {countries.map((country, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() => handleCountryClick(country)}>
                          {country.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </div>
                  {availableStates.length > 0 && (
                    <div ref={stateDropdownRef}>

                      <Dropdown.Menu
                        className={`position-absolute ${style.stateDrpDwm}`}
                        show={showStateDropdown}>
                        <Dropdown.Item disabled>States</Dropdown.Item>
                        {availableStates.map((state, index) => (
                          <Dropdown.Item
                            key={index}
                            onClick={() => handleStateClick(state)}>
                            {state}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </div>

                  )}

                </div>
              </InputGroup>
              <div ref={dropdownRef} className="mt-2">
                <Dropdown.Menu
                  className={style.suggestion}
                  show={showSuggestion}>
                  {suggestionList?.map((value, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => {
                        handleSuggestion(value);
                      }}>
                      {value}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </div>

              {/* Selected States */}
              <div className="mt-2">
                {selectedStates.length > 0 && (
                  <div className={style.selectedstatecontainer}>
                    {selectedStates.map((state, index) => (
                      <span key={index} className={style.selectedstatetag}>
                        {state}
                        <span
                          className="cross-tag"
                          onClick={() => handleStateRemove(state)}>
                          ×
                        </span>
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>

        <div>
          <div className={` ${style.maincentercontainer}`} style={{}}>
            <div className={style.dashboard_row}>
              <div className={style.centerBox}>
                <div>
                  {files?.length === 0 && (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "25vh" }}>
                      <h3>No Data Found</h3>
                    </div>
                  )}
                </div>


                <div className="container">
                  {/* This will execute the console.log when the component renders */}

                  <Row className="m-0 p-0">
                    {Array.isArray(files) && files
                      .filter(data => data?.description)
                      .sort((a, b) => {
                        const prioritized = ["Houston Coalition for Life", "Journey Home", "Life in Mercy"];
                        const aPriority = prioritized.findIndex(name =>
                          a.centerName?.toLowerCase().includes(name.toLowerCase()));
                        const bPriority = prioritized.findIndex(name =>
                          b.centerName?.toLowerCase().includes(name.toLowerCase()));

                        if (aPriority !== -1 && bPriority !== -1) return aPriority - bPriority;
                        if (aPriority !== -1) return -1;
                        if (bPriority !== -1) return 1;
                        return 0;
                      }).filter((data) => data?.description)
                      .map((data, index) => (

                        <Col className="p-3 " key={index} lg={4} md={6} sm={6}>
                          <div className={` bg-main ${style.centerCard}`}>
                            <div className="position-relative image-container" style={{ height: "150px" }}>
                              {data?.type === "unsupported" && (
                                <img
                                  className="w-100  h-100"
                                  src={`/defaultCenter.png`}
                                  alt="center"
                                />
                              )}
                              {data?.type === "image" && (
                                <img
                                  className="w-100 h-100 "
                                  src={`${data?.media}`}
                                  alt="center"
                                />
                              )}

                              {data?.type === "youtube" && (
                                <iframe
                                  src={`https://www.youtube.com/embed/${getYouTubeVideoId(data?.media)}`}
                                  frameborder='0'
                                  allow='encrypted-media'
                                  allowfullscreen
                                  title='video'
                                  width="100%"
                                  height="100%"
                                />
                              )}
                              {data?.type === "video" && (
                                <div className="w-100 h-100"  >
                                  <video
                                    preload="auto"
                                    controls
                                    width="100%"
                                    height="100%"
                                    style={{ objectFit: 'cover' }}
                                    // onClick={() => handleClick(data)}
                                    poster={'/aplay.svg'}

                                  >
                                    <source src={data.media} type={`video/${data.media.split('.').pop()}`} />
                                    Your browser does not support the video tag.
                                  </video>
                                </div>
                              )}
                              {(() => {
                                const isLive = liveSet.has(sanitizeFolderName(data?.centerName));
                                if (!isLive) return null;
                                return (
                                  <span className="pulse-dot" style={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    width: 12,
                                    height: 12,
                                    borderRadius: '50%',
                                    backgroundColor: '#22c55e',
                                    boxShadow: '0 0 0 2px rgba(255,255,255,0.9)',
                                    zIndex: 999,
                                    pointerEvents: 'none'
                                  }} title="Live" />
                                );
                              })()}

                              <div
                                class="overlay"
                                onClick={() =>
                                  (data?.type === "youtube" || data?.type === "video") &&
                                  handlePlay(data?.media)
                                }></div>
                            </div>
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClick(data)}>
                              <div
                                className="my-2 text-white"
                                style={{
                                  fontSize: "17px",
                                  textTransform: "capitalize",
                                  fontWeight: "bold",
                                  lineHeight: "30px",
                                }}>
                                {data?.centerName}
                              </div>
                              <div
                                style={{
                                  color: "white",
                                  minHeight: "120px",
                                  maxHeight: "120px",
                                  WebkitLineClamp: 4,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: "17px",
                                  lineHeight: "30px",
                                  fontWeight: "400",
                                  // whiteSpace:"nowrap"
                                }}>
                                {(() => {
                                  const key = sanitizeFolderName(data?.centerName);
                                  const desc = liveSet.has(key) && liveMeta?.[key]?.description ? liveMeta[key].description : data?.description;
                                  const cleanText = stripHtmlAndMarkdown(desc);
                                  return truncateString(cleanText, 120);
                                  // return truncateString(desc, 120);
                                })()}
                              </div>
                            </div>
                            <div
                              className=" d-flex justify-content-between align-items-center "
                              style={{ marginTop: "28px" }}>
                              <div style={{ fontSize: "12px", color: "white" }}>
                                {" "}
                                {data?.country === "United States"
                                  ? "US"
                                  : data.country}
                                {data?.state ? truncateText(data.state, 12) : ""}{" "}
                              </div>
                              <Button
                                variant="danger"
                                size="sm"
                                className="redbtn px-3 rounded-2"
                                onClick={() => handleClick(data)}>
                                Donate Now{" "}
                              </Button>
                            </div>
                          </div>
                        </Col>
                      ))}
                  </Row>
                </div>
                {showNext && (searchCenter || centerData?.length > 0) && (
                  <div className="text-center">
                    <Button variant="light" onClick={handleShowMore}>
                      Show More
                    </Button>
                  </div>
                )}
                {location?.pathname !== "/search-campaign" && (
                  <div className="text-center mt-5">
                    <p
                      onClick={() => navigate("/search-campaign")}
                      className={style.centerbrowse}>
                      {" "}
                      Browse all
                    </p>

                  </div>
                )}
                {centerList?.length < totalcenter &&
                  loadMore &&
                  !searchCenter && (
                    <div className="text-center">
                      <button onClick={handleLoadMore} className={style.loadmorebutton}>
                        Load More
                      </button>
                      <br></br>

                    </div>
                  )}
              </div>
            </div>
          </div>
          <VideoPlayer
            showVideoPlayer={showVideoPlayer}
            setShowVideoPlayer={setShowVideoPlayer}
            videoUrl={videoUrl}
          // isdata={isdata}
          />
        </div>

      </div>
    </>
  );
};

export default SearchCenter;
